// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"CareersStyle_DictionaryContainer__22bPB","customTitleh1":"CareersStyle_customTitleh1__dFB70"};